class HoverScarcityBanner extends HTMLElement {
  connectedCallback() {
    const [year, month, day] = (this.dataset.endDate || '').split('-').map(Number);
    const [hour, minute] = (this.dataset.endHour || '').split(':').map(Number);
    if (!year || !month || !day || isNaN(hour) || isNaN(minute)) {
      this.remove();
      return;
    }

    const target = Date.UTC(year, month - 1, day, hour, minute);
    this.endTime = target;
    for (let pass = 0; pass < 2; pass++) {
      const wall = this.pacificClock(this.endTime);
      this.endTime += target - Date.UTC(wall.year, wall.month - 1, wall.day, wall.hour, wall.minute);
    }

    if (this.endTime <= Date.now()) {
      this.remove();
      return;
    }

    const end = this.pacificClock(this.endTime);
    const monthName = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', month: 'short' }).format(new Date(this.endTime));
    this.querySelector('.hv-scarcity__ends-date').textContent = monthName + ' ' + end.day + ', ' + String(end.hour).padStart(2, '0') + ':' + String(end.minute).padStart(2, '0') + ' PT';

    const code = this.querySelector('.hv-scarcity__code');
    if (code) {
      code.addEventListener('click', async () => {
        const original = code.dataset.code || (code.dataset.code = code.textContent.trim());
        try {
          await navigator.clipboard.writeText(original);
        } catch (e) {}

        code.textContent = 'COPIED';
        clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => { code.textContent = original; }, 1200);
      });
    }

    this.updateCountdown();
    this.countdownInterval = setInterval(() => this.updateCountdown(), 15000);
  }

  disconnectedCallback() {
    clearInterval(this.countdownInterval);
  }

  pacificClock(timestamp) {
    const formatter = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    const clock = {};
    for (const part of formatter.formatToParts(new Date(timestamp))) clock[part.type] = +part.value;
    return clock;
  }

  updateCountdown() {
    const remaining = this.endTime - Date.now();
    if (remaining <= 0) {
      this.remove();
      return;
    }

    const minutes = Math.floor(remaining / 60000);
    this.querySelector('[data-unit="days"]').textContent = String(Math.floor(minutes / 1440)).padStart(2, '0');
    this.querySelector('[data-unit="hours"]').textContent = String(Math.floor(minutes / 60) % 24).padStart(2, '0');
    this.querySelector('[data-unit="minutes"]').textContent = String(minutes % 60).padStart(2, '0');
  }
}

customElements.define('hover-scarcity-banner', HoverScarcityBanner);

function injectScarcityBanner() {
  const template = document.getElementById('HvScarcityBannerTemplate');
  const addToCartButton = document.querySelector('button.gp-button-atc');
  if (!template || !addToCartButton || document.querySelector('hover-scarcity-banner')) return;

  const wrapper = addToCartButton.closest('gp-product-button') || addToCartButton;
  let next = wrapper.nextElementSibling;
  while (next && (next.tagName === 'SCRIPT' || next.tagName === 'STYLE')) next = next.nextElementSibling;
  const anchor = next && next.getAttribute('role') === 'presentation' && next.querySelector('picture, img') ? next : wrapper;

  anchor.insertAdjacentElement('afterend', template.content.firstElementChild.cloneNode(true));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', injectScarcityBanner);
} else {
  injectScarcityBanner();
}
